export const MenuIdAppSwitcher = 'APP_SWITCHER' as const;
